import { useParams } from 'react-router-dom';
import { useEffect, useMemo } from 'react';

import { useTransactionQuery } from '@ocx/graphql';
import { IReceipt, IReceiptOption } from '@ocx-app/modules/transaction/types';
import { mapReceipt } from '@ocx-app/modules/transaction/utils';
import { useGetTransactionReceiptOptions } from '@ocx-app/modules/transaction/hooks/useGetTransactionReceiptOptions';
import { useShowGenericErrorSnackbar } from '@ocx-app/hooks/useShowGenericErrorSnackbar';

type UseReceiptControllerReturns = {
  loading: boolean;
  receipt: IReceipt | null;
  options: IReceiptOption[];
};

export const useReceiptController = (): UseReceiptControllerReturns => {
  const handleError = useShowGenericErrorSnackbar();
  const { transactionId = '' } = useParams<{ transactionId: string }>();

  const { data, loading } = useTransactionQuery({
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
    variables: {
      uuid: transactionId,
    },
  });

  const receipt = mapReceipt(data?.transaction);
  const getTransactionReceiptOptions = useGetTransactionReceiptOptions();
  const options = useMemo(() => getTransactionReceiptOptions(receipt), [getTransactionReceiptOptions, receipt]);

  useEffect(() => {
    if (data?.transaction?.uuid && !receipt) {
      handleError();
    }
  }, [receipt, data?.transaction?.uuid, handleError]);

  return {
    loading,
    receipt,
    options,
  };
};
